import Button from './Button'
import { ButtonProps } from './types'

export function ButtonPrimary({ children, className, disableRing, ...rest }: ButtonProps): React.ReactElement {
  return (
    <Button
      className={
        `${className} bg-purple lg:hover:bg-purple-dark focus:bg-purple-focus lg:disabled:bg-purple ` +
        `${!disableRing ? 'ring-2 ring-purple hover:ring-purple-dark focus:ring-8 lg:focus:ring-purple-light' : ''} ` +
        `text-white`
      }
      {...rest}
    >
      {children}
    </Button>
  )
}
